import AddOrEditEvent from './AddOrEditEvent';

export default {
    ...AddOrEditEvent,
};
